import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IApiList, IPOSCategories, IPOSLaborEmployee } from 'types';
import { formatErrorMessages, getIntegrationNotFoundError } from 'utils/errors';
import * as API from '../../../api';
import * as Actions from './actions';
import { IGetPOSPayload, POS } from './types';

export function* getPosCategories({ payload }: IAction<POS.GET_POS_CATEGORIES_REQUEST, IGetPOSPayload>) {
  try {
    const { siteId } = payload;
    const response: ApiResponse<IPOSCategories> = yield call(API.Integrations.showPOSCategories, siteId);

    yield put(Actions.getPosCategoriesSuccess(response.body));
  } catch (error: any) {
    const integrationNotFoundError = getIntegrationNotFoundError(error);
    const formattedError = formatErrorMessages({ errors: error.body?.errors, statusCode: error.statusCode });
    yield put(Actions.getPosCategoriesError(formattedError, integrationNotFoundError || true));
  }
}

export function* getPosEmployees({ payload }: IAction<POS.GET_POS_EMPLOYEES_REQUEST, IGetPOSPayload>) {
  try {
    const { siteId } = payload;
    const response: ApiResponse<IApiList<IPOSLaborEmployee>> = yield call(API.Integrations.showPOSEmployees, siteId);

    yield put(Actions.getPosEmployeesSuccess({ employees: response.body.data }));
  } catch (error: any) {
    const integrationNotFoundError = getIntegrationNotFoundError(error);
    const formattedError = formatErrorMessages({ errors: error.body?.errors, statusCode: error.statusCode });
    yield put(Actions.getPosEmployeesError(formattedError, integrationNotFoundError || true));
  }
}

export function* watchGetPosCategories() {
  yield takeLatest(POS.GET_POS_CATEGORIES_REQUEST, getPosCategories);
}

export function* watchGetPosEmployees() {
  yield takeLatest(POS.GET_POS_EMPLOYEES_REQUEST, getPosEmployees);
}

function* posCategoriesSagas() {
  yield all([fork(watchGetPosCategories), fork(watchGetPosEmployees)]);
}
export { posCategoriesSagas };
